export default {
  activation: 'components.views.sign-up-view.email-sent.activation',
  checkEmail: 'components.views.sign-up-view.email-sent.check-email'
}
